import type { JiraWebRemoteIssueLink } from '../../types';

export const isJiraWebRemoteIssueLink = (entity: any): entity is JiraWebRemoteIssueLink =>
	entity.__typename === 'JiraWebRemoteIssueLink';

export const getJiraWebRemoteIssueLink = (issue: JiraWebRemoteIssueLink): string | null =>
	issue?.href ?? null;
